var map = {
	"./404.svg": 241,
	"./affordability-icon.svg": 149,
	"./app-store-icon.png": 242,
	"./back-arrow.svg": 57,
	"./blue-background-tick.png": 611,
	"./cam-icon.svg": 612,
	"./card-background-icon.svg": 613,
	"./card-icon.svg": 614,
	"./close.svg": 89,
	"./curefit-logo.svg": 615,
	"./doctor-cover.png": 221,
	"./doctor-landing-icon.svg": 222,
	"./doctor-mobile-cover.png": 223,
	"./dropdown-arrow-black.svg": 243,
	"./dropdown-arrow-white.svg": 244,
	"./dropout.png": 69,
	"./error-icon.svg": 65,
	"./error-red-cross-logo.svg": 238,
	"./facebook.svg": 207,
	"./fitnesstrainer-cover.png": 213,
	"./fitnesstrainer-mobile-cover.png": 214,
	"./fitnesstrainer-partnercover.svg": 203,
	"./footer-text.png": 157,
	"./google-play-icon.png": 245,
	"./hamburger-black.svg": 246,
	"./hamburger-white.svg": 247,
	"./hand-icon.svg": 616,
	"./in-progress.svg": 239,
	"./instagram.svg": 206,
	"./logo-dark.png": 617,
	"./nutritionist-cover.png": 210,
	"./nutritionist-mobile-cover.png": 212,
	"./nutritonists-landing-icon.svg": 211,
	"./partner-fit-white.svg": 204,
	"./partner-fit.svg": 202,
	"./pending-logo.svg": 240,
	"./person-outlined-icon.svg": 158,
	"./phychiatrist-mobile-cover.png": 229,
	"./physiotherapist-landing-icon.png": 226,
	"./physiotherapy-cover.png": 224,
	"./physiotherapy-mobile-cover.png": 225,
	"./play.svg": 156,
	"./psychiatrist-cover.png": 227,
	"./psychiatrists-landing-icon.png": 228,
	"./reach-icon.svg": 618,
	"./remove-icon.svg": 159,
	"./running-man-background-icon.svg": 619,
	"./signup-instruction-mobile.png": 231,
	"./signup-instruction.png": 230,
	"./smiley-icon.svg": 121,
	"./success-icon.svg": 120,
	"./therapist-cover.png": 218,
	"./therapist-mobile-cover.png": 220,
	"./therapitst-landing-icon.svg": 219,
	"./tick-mark-icon.svg": 620,
	"./time-background-icon.svg": 621,
	"./time-icon.svg": 148,
	"./transparent-icon.svg": 622,
	"./twitter.svg": 205,
	"./upload-avatar.svg": 209,
	"./upload-document-anyotherpaper-desktop.png": 248,
	"./upload-document-anyotherpaper-mobile.png": 249,
	"./upload-document-clearandvisible-desktop.png": 250,
	"./upload-document-clearandvisible-mobile.png": 251,
	"./upload-document-ruledpage-desktop.png": 252,
	"./upload-document-ruledpage-mobile.png": 253,
	"./upload-icon.svg": 70,
	"./uploaded-docs-logo.svg": 122,
	"./videos/home-new.mp4": 320,
	"./vman-dark.png": 623,
	"./warning-orange-icon.svg": 323,
	"./warning-red-logo.svg": 88,
	"./whatsapp-icon.svg": 232,
	"./wifi.svg": 254,
	"./yoga-landing-icon.svg": 216,
	"./yogaTrainer-cover.png": 215,
	"./yogaTrainer-mobile-cover.png": 217,
	"./youtube.svg": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;